<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>库存</el-breadcrumb-item>
      <el-breadcrumb-item>出库记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          label-position="left"
          label-width="70px"
        >
          <el-form-item
            label="出库单号"
            prop="number"
            v-if="!auth.isPlatformUser()"
          >
            <el-input
              size="small"
              autocomplete="off"
              v-model="searchForm.number"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="出货客户"
            prop="customer_name"
            v-if="!auth.isPlatformUser()"
          >
            <el-input
              size="small"
              autocomplete="off"
              v-model="searchForm.customer_name"
            ></el-input>
          </el-form-item>
          <el-form-item label="出货仓库" prop="stockroom_id">
            <el-select
              v-model="searchForm.stockroom_id"
              filterable
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in stockrooms"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="出库日期" prop="dates">
            <el-date-picker
              v-model="searchForm.dates"
              size="small"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button size="small" type="primary" @click="initData"
            >筛选</el-button
          >
          <el-button size="small" @click="resetForm('searchForm')"
            >重置</el-button
          >
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-table
        v-loading="loading"
        :data="lists"
        stripe
        header-row-class-name="q-products-header"
      >
        <el-table-column
          label="出库类型 / 订单号 / 客户"
          min-width="200px"
          v-if="!auth.isPlatformUser()"
        >
          <template slot-scope="scope">
            {{ scope.row.category_id == 1 ? '发货单出库' : '普通出库' }}
            <br v-if="scope.row.customer_order.id > 0" />
            {{ scope.row.customer_order.number }}
            <br v-if="scope.row.customer_order.id > 0" />
            {{ scope.row.customer_order.customer.name }}
          </template>
        </el-table-column>
        <el-table-column label="产品明细" min-width="200">
          <template slot-scope="scope">
            <span class="item-tag" v-for="item in scope.row.items">
              {{ item.item.name }}
              <i>x{{ item.item_number }}</i>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="applicant.name"
          label="申请人"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="transactor.name"
          label="经办人"
          align="center"
        ></el-table-column>
        <el-table-column label="出库日期" align="center">
          <template slot-scope="scope">{{
            scope.row.stock_out_date
              ? $time(scope.row.stock_out_date).format('YYYY-MM-DD')
              : ''
          }}</template>
        </el-table-column>
        <el-table-column label="总金额" align="center">
          <template slot-scope="scope">{{
            scope.row.amount.toFixed(2)
          }}</template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              plain
              @click="showBillDetail(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :current-page.sync="page"
        @current-change="handlePageChange"
        layout="total, prev, pager, next"
        :page-size="size"
        :total="total"
      ></el-pagination>
    </div>
    <bill-detail-dialog
      :model="model"
      :outBill="true"
      :show.sync="dialogVisible"
    ></bill-detail-dialog>
  </div>
</template>

<script>
import billDetailDialog from '@/components/bill_detail'
import { stockOutBillList, stockroomList } from '@/service/getData'
import { clone } from '@/util'
import auth from '@/util/auth'

export default {
  components: {
    billDetailDialog,
  },
  data() {
    return {
      auth,
      searchForm: {
        status: 2,
        number: '',
        customer_name: '',
        stockroom_id: '',
        dates: '',
      },
      stockrooms: [],
      loading: true,
      page: 1,
      size: 30,
      total: 0,
      lists: [],
      model: {},
      dialogVisible: false,
    }
  },
  created() {
    this.initData()
    this.getStockroomList()
  },
  methods: {
    async initData() {
      let params = clone(this.searchForm)
      params.page = this.page - 1
      params.size = this.size

      let dates = this.searchForm.dates
      if (dates && dates.length == 2) {
        params.start_time = dates[0]
        params.end_time = dates[1]
      }

      let res = await stockOutBillList(params)
      this.lists = res.data.list
      this.total = res.data.total
      this.loading = false
    },
    async getStockroomList() {
      let res = await stockroomList({ page: 0, size: 1000 })
      if (res.code == 0) {
        this.stockrooms = res.data.list
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.page = 1
      this.initData()
    },
    handlePageChange(e) {
      this.page = e
      this.loading = true
      this.initData()
    },
    showBillDetail(item) {
      this.dialogVisible = true
      this.model = item
    },
  },
}
</script>
<style scoped>
.tag {
  float: left;
  max-width: 100%;
  text-overflow: ellipsis;
  height: 20px;
  line-height: 20px;
  padding: 0 10px;
  border: 1px solid #ccc;
  font-size: 12px;
  margin: 2px 0;
  clear: both;
  background-image: linear-gradient(to right, #98c9fd55, #fff);
}
.tag i {
  margin-left: 10px;
}
</style>